/** Browser/network blips during read paths — not product defects. */
export function isTransientNetworkError(error: unknown): boolean {
  if (error instanceof Error) {
    if (error.name === 'AbortError') return true
    const message = error.message
    return (
      /failed to fetch/i.test(message) ||
      /networkerror/i.test(message) ||
      /load failed/i.test(message) ||
      /err_network/i.test(message)
    )
  }

  if (error && typeof error === 'object' && 'message' in error) {
    const message = String((error as { message: unknown }).message)
    if (!message.trim()) return false
    return (
      /failed to fetch/i.test(message) ||
      /networkerror/i.test(message) ||
      /load failed/i.test(message)
    )
  }

  return false
}
